/**
 * Fix FG (2026-10-08): tipo de cambio USD → Gs. del día (o de una fecha). Lo da el
 * backend (/api/tipo-cambio): automático (BCP) con corrección manual en Configuración.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../contexts/AuthContext";

export function useTipoCambio(fecha, activo = true) {
  const [tc, setTc] = useState(null);
  useEffect(() => {
    if (!activo) return undefined;
    let vivo = true;
    axios.get(`${API}/tipo-cambio${fecha ? `?fecha=${fecha}` : ""}`, { withCredentials: true })
      .then(({ data }) => { if (vivo) setTc(data); })
      .catch(() => { if (vivo) setTc(null); });
    return () => { vivo = false; };
  }, [fecha, activo]);
  return tc;
}

export const fmtTC = (v) => `1 USD = Gs. ${Math.round(Number(v || 0)).toLocaleString("es-PY")}`;
